import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#about", label: "About" },
  { href: "#verticals", label: "Businesses" },
  { href: "#footprint", label: "Global Footprint" },
  { href: "#leadership", label: "Leadership" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-nav" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <img
            src="https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/u0h0fq87_KDM%20logo.png"
            alt="KDM Group"
            className="h-12 w-auto"
          />
          <span className="overline hidden sm:inline">Group</span>
        </a>

        {/* Desktop links */}
        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[13px] tracking-[0.18em] uppercase font-medium text-[--kdm-ink] hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <a
          href="#contact"
          data-testid="nav-cta"
          className="hidden lg:inline-flex btn-gold !py-3 !px-6"
        >
          Engage Us
        </a>

        {/* Mobile toggle */}
        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile sheet */}
      {open && (
        <div className="lg:hidden glass-nav border-t border-black/5">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.18em] uppercase font-medium"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="btn-gold mt-2 w-fit"
            >
              Engage Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
